import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { syncDatabase } from "../utils/offlineSync";

function AuthPage() {
  const [searchParams] = useSearchParams();
  const to = searchParams.get("to") || "/";

  const { isLoading, getAccessTokenSilently, user } = useAuth0();
  const nav = useNavigate();

  useEffect(() => {
    if (isLoading) {
      return;
    }
    // set the token
    getAccessTokenSilently()
      .then((token) => {
        // set token
        localStorage.setItem("token", token);
        localStorage.setItem("username", user?.name || "");
        // forward to application
        syncDatabase(token).then(() => {
          nav(to);
        });
      })
      .catch(() => {
        nav("/login");
      });
  }, [isLoading, getAccessTokenSilently, nav, to]);

  return <></>;
}

export default AuthPage;
